import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 1rem 2rem;
  text-align: center;
  background-color: #eee; /* Light gray background */
  color: #333;
`;

const Copyright = styled.p`
  margin: 0;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <a href="https://tech2us.ma" target="_blank" rel="noopener noreferrer">
      <Copyright>&copy; {new Date().getFullYear()} tech2us.ma</Copyright>
      </a>
    </FooterContainer>
  );
};

export default Footer;
